<template>
    <div id="guia-de-presentes">
        <div class="content">
            <h1>Guia de Presentes Chico Rei: várias opções em um só lugar!</h1>
            <p>
                O Guia de Presente da Chico Rei chegou para facilitar a sua escolha e aqui você
                encontra opções de camisetas à pronta entrega, acessórios e itens de decoração pra
                lá de charmosos.
            </p>
        </div>

        <div class="content">
            <h2 class="mt-4">Precisa de ajuda? Converse com a gente!</h2>
            <p>
                Se você ainda não tem certeza do que comprar, clique no chat abaixo para iniciar uma
                conversa e receba uma lista de produtos personalizados!
            </p>

            <div class="open-chat">
                <p v-if="!openChat" @click="openChat = true" class="cursor-pointer mt-4 mb-4">
                    Abrir chat <i class="icon-cr icon-plus mx-0" />
                </p>
                <div v-else class="chatbox">
                    <div class="chat-header">
                        <div class="d-flex">
                            <div class="icon-tag">
                                <i class="icon-cr icon-logo" />
                            </div>
                            <h3 class="ml-3">Chico Rei</h3>
                        </div>

                        <div class="chat-close cursor-pointer" @click="closeChat">
                            <span class="hidden-md-down">Fechar chat</span>
                            <span class="hidden-md-up mt-1">Fechar</span>
                            <i class="icon-cr icon-close" />
                        </div>
                    </div>

                    <div class="all-messages" id="all-messages">
                        <div
                            v-for="(item, index) in messages"
                            :key="index"
                            :style="{
                                'background-color': item.side === 2 ? '#B5D9B2' : '#D9C2B2',
                                'border-radius':
                                    item.side === 2 ? '10px 10px 0 10px' : '10px 10px 10px 0',
                                'align-self': item.side === 1 ? 'start' : 'end',
                                'margin-left': item.side === 1 ? '10px' : '',
                                'margin-right': item.side === 2 ? '10px' : '',
                            }"
                        >
                            <span v-if="item.type == 'text'">{{ item.content }}</span>
                            <ul v-if="item.options">
                                <li
                                    v-for="option in item.options"
                                    class="d-flex flex-align-center cursor-pointer"
                                    @click="sendMessage(item.iteration, option.event)"
                                >
                                    <i class="icon-cr icon-chevron-right mr-2" />{{ option.text }}
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="chat-text-field">
                        <div class="message">
                            <div>{{ currentMessage }}</div>
                        </div>
                        <div class="send-btn cursor-pointer" @click="sendMessage(0)">
                            <i class="icon-cr icon-chevron-right" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <div class="content">
                <h2 class="mt-4">Envio imediato para quem tem pressa em presentear</h2>
                <p
                    v-if="
                        !Object.values(sendImmediate).some(
                            (item) => item.showSendImmediate === true
                        )
                    "
                >
                    Nossa seleção de camisetas Vapt-Vupt conta apenas com peças à pronta entrega que
                    chegam até você em um piscar de olhos.
                </p>
                <p v-else>
                    Selecione o tamanho e modelagem de camiseta que mais combina com quem você vai
                    presentear e veja uma lista só com produtos de envio imediato
                </p>
            </div>
            <div class="hidden-md-down content">
                <div
                    v-for="(item, itemIndex) in sendImmediate"
                    :key="itemIndex"
                    class="pos-relative overflow-hidden"
                    @mouseenter="sendImmediate[itemIndex].showSendImmediate = true"
                    @mouseleave="sendImmediate[itemIndex].showSendImmediate = false"
                >
                    <img
                        :data-src="item.img_desktop"
                        :alt="item.alt"
                        class="lazy lazy-fade img-responsive mb-3"
                    />
                    <div
                        class="send-immediate"
                        :style="{
                            left: sendImmediate[itemIndex].showSendImmediate ? '0' : '-590px',
                        }"
                    >
                        <p>
                            Confira apenas nossas camisetas {{ textSendImmediate[itemIndex] }} com
                            <strong>prazo de envio reduzido</strong>
                        </p>
                        <p>Selecione o tamanho desejado abaixo:</p>
                        <div class="list-options">
                            <p
                                class="text-bold text-uppercase mr-4"
                                :style="{
                                    borderBottom: item.regularEffect ? '2px solid black' : 'none',
                                }"
                            >
                                Regular:
                            </p>
                            <div
                                class="sizes"
                                @mouseenter="item.regularEffect = true"
                                @mouseleave="item.regularEffect = false"
                            >
                                <a
                                    class="option-size text-no-decoration"
                                    v-for="(size, sizeIndex) in sizes"
                                    :key="sizeIndex"
                                    :href="computedUrls[itemIndex][sizeIndex]"
                                >
                                    {{ size }}
                                </a>
                            </div>
                        </div>
                        <div class="list-options">
                            <p
                                class="text-bold text-uppercase mr-3"
                                :style="{
                                    borderBottom: item.babylookEffect ? '2px solid black' : 'none',
                                }"
                            >
                                Babylook:
                            </p>
                            <div
                                class="sizes"
                                @mouseenter="item.babylookEffect = true"
                                @mouseleave="item.babylookEffect = false"
                            >
                                <a
                                    class="option-size text-no-decoration"
                                    v-for="(size, sizeIndex) in sizes"
                                    :key="sizeIndex"
                                    :href="computedUrls[itemIndex][sizeIndex]"
                                >
                                    {{ size }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="hidden-md-up send-immediate-mobile">
                <div v-for="(item, itemIndex) in sendImmediate" class="item mb-3">
                    <div class="content">
                        <div class="d-flex pos-relative">
                            <div class="item-text">
                                <h2>{{ item.alt }}</h2>
                                <p>
                                    Confira apenas nossas camisetas com
                                    <strong>prazo de envio reduzido</strong>.
                                </p>
                                <p>Selecione o tamanho desejado abaixo:</p>
                            </div>
                            <div class="item-img">
                                <img
                                    :data-src="item.img_mobile"
                                    alt="Chico Rei"
                                    class="lazy lazy-fade img-responsive"
                                />
                            </div>
                        </div>

                        <h3 class="mb-3">Modelagem Regular:</h3>
                        <div class="sizes mb-3">
                            <a
                                class="option-size text-no-decoration"
                                v-for="(size, sizeIndex) in sizes"
                                :key="sizeIndex"
                                :href="computedUrls[itemIndex][sizeIndex]"
                            >
                                {{ size }}
                            </a>
                        </div>
                        <h3 class="mb-3">Modelagem Babylook:</h3>
                        <div class="sizes mb-3">
                            <a
                                class="option-size text-no-decoration"
                                v-for="(size, sizeIndex) in sizes"
                                :key="sizeIndex"
                                :href="computedUrls[itemIndex][sizeIndex]"
                            >
                                {{ size }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <div class="content">
                <h2 class="mt-4">Seleção de presentes para amigo oculto</h2>
                <p>
                    Presentear alguém é um jeito de deixar com o outro um pouquinho da gente! Para
                    te ajudar ainda mais, nós separamos nossos produtos por preço, basta clicar no
                    banner para conferir.
                </p>
            </div>
            <div class="hidden-md-down content">
                <div class="list-imgs">
                    <a
                        class="back-item text-no-decoration"
                        v-for="(gift, index) in presentoes"
                        :key="index"
                        v-if="index < 4"
                        :href="gift.redirect"
                    >
                        <p>
                            Presentões <br /><span>{{ gift.alt }}</span>
                        </p>
                        <img :data-src="gift.img_desktop" :alt="gift.alt" class="lazy lazy-fade" />
                    </a>
                </div>
                <a
                    class="back-item-5 text-no-decoration cursor-pointer"
                    :href="$scope.URL + `loja/preco-acima-de-100/`"
                >
                    <div v-for="(gift, index) in presentoes" :key="index" v-if="index === 4">
                        <img
                            :data-src="gift.img_desktop"
                            :alt="gift.alt"
                            class="lazy lazy-fade img-4"
                        />
                    </div>
                    <div>
                        <p>Presentões <br /><span>A partir de R$100</span></p>
                    </div>
                    <div v-for="(gift, index) in presentoes" :key="index" v-if="index === 5">
                        <img
                            :data-src="gift.img_desktop"
                            :alt="gift.alt"
                            class="lazy lazy-fade img-5"
                        />
                    </div>
                </a>
            </div>
            <div id="presentoes-carousel" class="hidden-md-up mt-4">
                <div class="d-inline-flex w-full">
                    <ul
                        class="carousel-stores-img horizontal-list no-scrollbar"
                        @scroll="scrollEvent = $event"
                        id="img-presentoes-list"
                    >
                        <a
                            v-for="(image, index) in presentoes"
                            :href="image.redirect"
                            v-if="index <= 4"
                        >
                            <div>
                                <img
                                    :data-src="image.img_mobile"
                                    :alt="image.alt"
                                    style="max-width: 260px"
                                    class="lazy lazy-fade"
                                />
                            </div>
                        </a>
                    </ul>
                </div>
                <horizontal-scrollbar
                    class="hidden-md-up"
                    :scroll-event="scrollEvent"
                    :button-height="110"
                    :id-list="'img-presentoes-list'"
                ></horizontal-scrollbar>
            </div>
        </div>

        <div class="content hidden-xs-down mt-3">
            <img
                :data-src="`${$scope.CDN_IMAGES}/images/hotsites/guia-de-presentes/bnr_embalagem_guiadepresentes_desktop_100524.png?auto=compress,format&q=65`"
                alt="Guia de presentes"
                class="lazy lazy-fade img-responsive"
            />
        </div>
        <div class="hidden-xs-up mt-3">
            <img
                :data-src="`${$scope.CDN_IMAGES}/images/hotsites/guia-de-presentes/bnr_embalagem_guiadepresentes_mobile_100524.png?auto=compress,format&q=65`"
                alt="Guia de presentes"
                class="lazy lazy-fade img-responsive"
            />
        </div>

        <div>
            <div class="content">
                <h2 class="mt-4">Em Família</h2>
                <p>Dicas rápidas para você presentar mãe, pai, avô, avó e mais!</p>
            </div>

            <div class="content d-flex flex-justify-between hidden-xs-down">
                <a
                    v-for="item in specificProducts"
                    class="cursor-pointer text-no-decoration"
                    :href="item.redirect"
                >
                    <picture>
                        <source :srcset="item.img_mobile" media="(max-width: 576px)" />
                        <img
                            :data-src="item.img_desktop"
                            :alt="item.alt"
                            class="lazy lazy-fade img-responsive"
                        />
                    </picture>
                </a>
            </div>

            <div class="d-flex flex-justify-between hidden-xs-up" style="gap: 1rem">
                <a
                    v-for="item in specificProducts"
                    :href="item.redirect"
                    class="text-no-decoration cursor-pointer"
                >
                    <picture>
                        <source :srcset="item.img_mobile" media="(max-width: 576px)" />
                        <img
                            :data-src="item.img_desktop"
                            :alt="item.alt"
                            class="lazy lazy-fade img-responsive"
                        />
                    </picture>
                </a>
            </div>
        </div>

        <div class="content">
            <h2 class="mt-4">A inspiração que você estava procurando está aqui!</h2>
            <p>
                No blog da Chico Rei você encontra algumas dicas para te inspirar na hora de
                escolher aquele presente especial!
            </p>
            <div class="list-imgs mt-4 hidden-md-down">
                <div v-for="article in articles" class="article">
                    <a class="text-no-decoration" :href="article.redirect" target="_blank">
                        <img
                            :data-src="article.img_desktop"
                            :alt="article.alt"
                            class="lazy lazy-fade img-responsive cursor-pointer"
                        />
                    </a>
                    <span class="text-bold text-uppercase">{{ article.text }}</span>
                    <div class="d-flex flex-justify-between flex-align-center">
                        <span>{{ article.date }}</span>
                        <span>por: {{ article.by }}</span>
                    </div>
                </div>
            </div>

            <div id="articles-carousel" class="hidden-md-up mt-4">
                <div class="d-inline-flex w-full">
                    <ul
                        class="carousel-stores-img horizontal-list no-scrollbar"
                        @scroll="scrollEvent = $event"
                        id="img-articles-list"
                    >
                        <a v-for="article in articles">
                            <div class="d-flex flex-column">
                                <a
                                    class="text-no-decoration"
                                    :href="article.redirect"
                                    target="_blank"
                                >
                                    <img
                                        :data-src="article.img_desktop"
                                        :alt="article.alt"
                                        class="lazy lazy-fade img-responsive"
                                    />
                                </a>

                                <span class="text-bold text-uppercase">{{ article.text }}</span>
                                <div class="d-flex flex-justify-between flex-align-center">
                                    <span>{{ article.date }}</span>
                                    <span>por: {{ article.by }}</span>
                                </div>
                            </div>
                        </a>
                    </ul>
                </div>
                <horizontal-scrollbar
                    class="hidden-md-up"
                    :scroll-event="scrollEvent"
                    :button-height="110"
                    :id-list="'img-articles-list'"
                ></horizontal-scrollbar>
            </div>
        </div>

        <div>
            <div class="content">
                <h2 class="mt-4">Produtos que expressam personalidade</h2>
                <p>
                    Todo mundo tem um amigo com características marcantes e você pode encontrar o
                    presente perfeito visitando uma de nossas categorias.
                </p>
            </div>

            <div class="hidden-md-down content">
                <div class="list-imgs">
                    <a
                        class="back-item-personality text-no-decoration cursor-pointer"
                        v-for="img in personalities"
                        :href="img.redirect"
                    >
                        <p>
                            Presentões <br /><span>{{ img.alt }}</span>
                        </p>
                        <img :data-src="img.img_desktop" :alt="img.alt" class="lazy lazy-fade" />
                    </a>
                </div>
            </div>
            <div id="personalities-carousel" class="hidden-md-up mt-4">
                <div class="d-inline-flex w-full">
                    <ul
                        class="carousel-stores-img horizontal-list no-scrollbar"
                        @scroll="scrollEvent = $event"
                        id="img-personalities-list"
                    >
                        <a
                            v-for="image in personalities"
                            :href="image.redirect"
                            class="text-no-decoration"
                        >
                            <div>
                                <img
                                    :data-src="image.img_mobile"
                                    :alt="image.alt"
                                    class="lazy lazy-fade img-responsive"
                                />
                            </div>
                        </a>
                    </ul>
                </div>
                <horizontal-scrollbar
                    class="hidden-md-up"
                    :scroll-event="scrollEvent"
                    :button-height="110"
                    :id-list="'img-personalities-list'"
                ></horizontal-scrollbar>
            </div>
        </div>

        <div class="content">
            <h2 class="mt-4">Acerte no presente sem preocupações</h2>
            <p>
                Com o nosso vale-presente não tem erro! Basta selecionar o vale com valor desejado e
                pronto, em alguns instantes ele chegará na sua caixa de e-mail e você poderá
                enviá-lo pelas redes sociais ou, quem sabe, até imprimir. O importante é dar voz à
                criatividade!
            </p>

            <div class="vales">
                <img
                    class="lazy lazy-fade vale-principal"
                    :data-src="
                        this.$scope.CDN_IMAGES +
                        `/images/site/hotsites/vale_presente_desktop.png?auto=compress,format&q=65`
                    "
                />
                <div class="list-imgs-sec">
                    <a v-for="vale in vales" :href="vale.redirect">
                        <picture class="cursor-pointer">
                            <source :srcset="vale.img_mobile" media="(max-width: 992px)" />
                            <img
                                v-if="!vale.hover"
                                :data-src="vale.img_desktop"
                                :alt="vale.alt"
                                width="100%"
                                class="lazy lazy-fade"
                                @mouseenter="vale.hover = true"
                            />
                            <img
                                v-else
                                :data-src="vale.img_hover"
                                :alt="vale.alt"
                                width="100%"
                                class="lazy lazy-fade"
                                @mouseleave="vale.hover = false"
                            />
                        </picture>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import HorizontalScrollbar from '../common/container/HorizontalScrollbar.vue';
    import GiftGuideCatalogLink from './GiftGuideCatalogLink.vue';

    export default {
        name: 'GiftGuideV2',
        components: { HorizontalScrollbar },
        el: '#guia-de-presentes-vue',

        mixins: [GiftGuideCatalogLink],

        data() {
            return {
                openChat: false,
                scrollEvent: null,
                currentMessage: 'Olá, Chico! Quero ajuda para escolher um presente',

                textSendImmediate: { 0: 'brasilidade', 1: 'cinema', 2: 'geek', 3: 'humor' },
                events: [],

                showShirts: null,
                selectedGender: null,
                selectedCategory: null,
                selectedSize: null,
                selectedTypeProduct: null,

                sendImmediate: [
                    {
                        alt: 'Camisetas de brasilidade com envio imediato',
                        theme: 'brasilidade',
                        img_desktop:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/guia-de-presentes/bnr_guiadepresentes_envioimediato_desktop_100524_01.png?auto=compress,format&q=65',
                        img_mobile:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/guia-de-presentes/bnr_guiadepresentes_envioimediato_mobile_100524_01.png?auto=compress,format&q=65',
                        regularEffect: false,
                        babylookEffect: false,
                        showSendImmediate: false,
                    },
                    {
                        alt: 'Camisetas de cinema com envio imediato',
                        theme: 'de-filmes',
                        img_desktop:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/guia-de-presentes/bnr_guiadepresentes_envioimediato_desktop_100524_02.png?auto=compress,format&q=65',
                        img_mobile:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/guia-de-presentes/bnr_guiadepresentes_envioimediato_mobile_100524_02.png?auto=compress,format&q=65',
                        regularEffect: false,
                        babylookEffect: false,
                        showSendImmediate: false,
                    },
                    {
                        alt: 'Camisetas geek com envio imediato',
                        theme: 'geek',
                        img_desktop:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/guia-de-presentes/bnr_guiadepresentes_envioimediato_desktop_100524_03.png?auto=compress,format&q=65',
                        img_mobile:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/guia-de-presentes/bnr_guiadepresentes_envioimediato_mobile_100524_03.png?auto=compress,format&q=65',
                        regularEffect: false,
                        babylookEffect: false,
                        showSendImmediate: false,
                    },
                    {
                        alt: 'Camisetas de humor com envio imediato',
                        theme: 'humor',
                        img_desktop:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/guia-de-presentes/bnr_guiadepresentes_envioimediato_desktop_100524_04.png?auto=compress,format&q=65',
                        img_mobile:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/guia-de-presentes/bnr_guiadepresentes_envioimediato_mobile_100524_04.png?auto=compress,format&q=65',
                        regularEffect: false,
                        babylookEffect: false,
                        showSendImmediate: false,
                    },
                ],

                presentoes: [
                    {
                        alt: 'Até R$40',
                        img_desktop:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/guia-de-presentes/bnr_guiadepresentes_carrossel_amigooculto_desktop_100524_01.png?auto=compress,format&q=65&fit=crop&w=300&h=400',
                        img_mobile:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/guia-de-presentes/bnr_guiadepresentes_carrossel_amigooculto_mobile_100524_01.png?auto=compress,format&q=65',
                        redirect: this.$scope.URL + 'loja/preco-ate-40/',
                    },
                    {
                        alt: 'Até R$60',
                        img_desktop:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/guia-de-presentes/bnr_guiadepresentes_carrossel_amigooculto_desktop_100524_02.png?auto=compress,format&q=65&fit=crop&w=300&h=400',
                        img_mobile:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/guia-de-presentes/bnr_guiadepresentes_carrossel_amigooculto_mobile_100524_02.png?auto=compress,format&q=65',
                        redirect: this.$scope.URL + 'loja/preco-de-40-60/',
                    },
                    {
                        alt: 'Até R$80',
                        img_desktop:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/guia-de-presentes/bnr_guiadepresentes_carrossel_amigooculto_desktop_100524_03.png?auto=compress,format&q=65&fit=crop&w=300&h=400',
                        img_mobile:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/guia-de-presentes/bnr_guiadepresentes_carrossel_amigooculto_mobile_100524_03.png?auto=compress,format&q=65',
                        redirect: this.$scope.URL + 'loja/preco-de-60-80/',
                    },
                    {
                        alt: 'Até R$100',
                        img_desktop:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/guia-de-presentes/bnr_guiadepresentes_carrossel_amigooculto_desktop_100524_04.png?auto=compress,format&q=65&fit=crop&w=300&h=400',
                        img_mobile:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/guia-de-presentes/bnr_guiadepresentes_carrossel_amigooculto_mobile_100524_04.png?auto=compress,format&q=65',
                        redirect: this.$scope.URL + 'loja/preco-de-80-100/',
                    },
                    {
                        alt: 'A partir de R$100',
                        img_desktop:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/guia-de-presentes/bnr_guiadepresentes_carrossel_amigooculto_desktop_100524_esquerda.png?auto=compress,format&q=65',
                        img_mobile:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/guia-de-presentes/bnr_guiadepresentes_carrossel_amigooculto_mobile_100524_05.png?auto=compress,format&q=65',
                    },
                    {
                        alt: 'A partir de R$100',
                        img_desktop:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/guia-de-presentes/bnr_guiadepresentes_carrossel_amigooculto_desktop_100524_direita.png?auto=compress,format&q=65',
                        img_mobile:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/guia-de-presentes/bnr_guiadepresentes_carrossel_amigooculto_mobile_100524_05.png?auto=compress,format&q=65',
                    },
                ],
                articles: [
                    {
                        alt: 'Presente de Amigo Secreto até R$60,00',
                        img_desktop:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/guia-de-presentes/amigo-secreto.png?auto=compress,format&q=65',
                        redirect:
                            'https://blog.chicorei.com/10-dicas-de-presente-de-amigo-secreto-ate-r-60-00/',
                        text: 'Presente de Amigo Secreto até R$60,00',
                        date: '15/12/2023',
                        by: 'CAMILA WENDLING',
                    },
                    {
                        alt: '10 estampas que fizeram sucesso por aqui em 2023',
                        img_desktop:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/guia-de-presentes/sucessos-2023.png?auto=compress,format&q=65',
                        redirect:
                            'https://blog.chicorei.com/presente-de-natal-10-estampas-que-fizeram-sucesso-por-aqui-em-2023/',
                        text: '10 estampas que fizeram sucesso por aqui em 2023',
                        date: '15/12/2023',
                        by: 'CAMILA WENDLING',
                    },
                    {
                        alt: '3 dicas de looks de inverno com pochete',
                        img_desktop:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/guia-de-presentes/como-usar-pochete.png?auto=compress,format&q=65',
                        redirect:
                            'https://blog.chicorei.com/3-dicas-de-looks-de-inverno-com-pochete/',
                        text: '3 dicas de looks de inverno com pochete',
                        date: '16/07/2023',
                        by: 'CAMILA WENDLING',
                    },
                ],
                personalities: [
                    {
                        alt: 'Para Amantes de Café',
                        img_desktop:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/guia-de-presentes/bnr_guiadepresentes_caracteristicaspessoais_desktop_100524_01.png?auto=compress,format&q=65&fit=crop&w=500&h=600',
                        img_mobile:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/guia-de-presentes/bnr_guiadepresentes_carrossel_carcteristicaspessoais_mobile_100524_01.png?auto=compress,format&q=65&fit=crop&w=260&h=440',
                        redirect: this.$scope.URL + 'loja/cafe/',
                    },
                    {
                        alt: 'Para Home Officers',
                        img_desktop:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/guia-de-presentes/bnr_guiadepresentes_caracteristicaspessoais_desktop_100524_02.png?auto=compress,format&q=65&fit=crop&w=500&h=600',
                        img_mobile:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/guia-de-presentes/bnr_guiadepresentes_carrossel_carcteristicaspessoais_mobile_100524_02.png?auto=compress,format&q=65&fit=crop&w=260&h=440',
                        redirect: this.$scope.URL + 'casa/',
                    },
                    {
                        alt: 'Para Pai e Mãe de Pets',
                        img_desktop:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/guia-de-presentes/bnr_guiadepresentes_caracteristicaspessoais_desktop_100524_03.png?auto=compress,format&q=65&fit=crop&w=500&h=600',
                        img_mobile:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/guia-de-presentes/bnr_guiadepresentes_carrossel_carcteristicaspessoais_mobile_100524_03.png?auto=compress,format&q=65&fit=crop&w=260&h=440',
                        redirect: this.$scope.URL + 'loja/cafe/',
                    },
                ],
                vales: [
                    {
                        alt: 'Vale-Presente R$50',
                        img_desktop:
                            this.$scope.CDN_IMAGES +
                            '/images/site/hotsites/vale_50.png?auto=compress,format&q=65',
                        img_mobile:
                            this.$scope.CDN_IMAGES +
                            '/images/site/hotsites/vale_50_mobile.png?auto=compress,format&q=65',
                        img_hover:
                            this.$scope.CDN_IMAGES +
                            '/images/site/hotsites/vale_50_hover.png?auto=compress,format&q=65',
                        hover: false,
                        redirect: '/cart.php?produto_id=2978&variation_id=1113&quantidade=1',
                    },
                    {
                        alt: 'Vale-Presente R$100',
                        img_desktop:
                            this.$scope.CDN_IMAGES +
                            '/images/site/hotsites/vale_100.png?auto=compress,format&q=65',
                        img_mobile:
                            this.$scope.CDN_IMAGES +
                            '/images/site/hotsites/vale_100_mobile.png?auto=compress,format&q=65',
                        img_hover:
                            this.$scope.CDN_IMAGES +
                            '/images/site/hotsites/vale_100_hover.png?auto=compress,format&q=65',
                        hover: false,
                        redirect: '/cart.php?produto_id=2978&variation_id=1114&quantidade=1',
                    },
                    {
                        alt: 'Vale-Presente R$150',
                        img_desktop:
                            this.$scope.CDN_IMAGES +
                            '/images/site/hotsites/vale_150.png?auto=compress,format&q=65',
                        img_mobile:
                            this.$scope.CDN_IMAGES +
                            '/images/site/hotsites/vale_150_mobile.png?auto=compress,format&q=65',
                        img_hover:
                            this.$scope.CDN_IMAGES +
                            '/images/site/hotsites/vale_150_hover.png?auto=compress,format&q=65',
                        hover: false,
                        redirect: '/cart.php?produto_id=2978&variation_id=1115&quantidade=1',
                    },
                    {
                        alt: 'Vale-Presente R$200',
                        img_desktop:
                            this.$scope.CDN_IMAGES +
                            '/images/site/hotsites/vale_200.png?auto=compress,format&q=65',
                        img_mobile:
                            this.$scope.CDN_IMAGES +
                            '/images/site/hotsites/vale_200_mobile.png?auto=compress,format&q=65',
                        img_hover:
                            this.$scope.CDN_IMAGES +
                            '/images/site/hotsites/vale_200_hover.png?auto=compress,format&q=65',
                        hover: false,
                        redirect: '/cart.php?produto_id=2978&variation_id=1116&quantidade=1',
                    },
                ],

                specificProducts: [
                    {
                        alt: 'Malhas Especiais',
                        img_desktop:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/guia-de-presentes/bnr_guiadepresentes_produtosespecificos_desktop_100524_01.png?auto=compress,format&q=65',
                        img_mobile:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/guia-de-presentes/bnr_guiadepresentes_produtosespecificos_mobile_100524_01.png?auto=compress,format&q=65',
                        redirect: this.$scope.URL + 'malhas-especiais/',
                    },
                    {
                        alt: 'Estampas Minimalistas',
                        img_desktop:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/guia-de-presentes/bnr_guiadepresentes_produtosespecificos_desktop_100524_02_fix.png?auto=compress,format&q=65',
                        img_mobile:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/guia-de-presentes/bnr_guiadepresentes_produtosespecificos_mobile_100524_02.png?auto=compress,format&q=65',
                        redirect: this.$scope.URL + 'camiseta/minimalista/',
                    },
                ],

                messages: [],
                sizes: ['PP', 'P', 'M', 'G', 'GG', '2GG', '3GG', '4GG'],

                computedUrls: null,
            };
        },

        watch: {
            sendImmediate: {
                immediate: true,
                deep: true,
                handler(to) {
                    if (to) {
                        this.computeUrls();
                    }
                },
            },
        },

        computed: {
            url() {
                return this.buildUrl(this.selectedTypeProduct, {
                    category: this.selectedCategory.value,
                });
            },

            shirtsUrl() {
                return this.buildUrl('camiseta', {
                    size: (this.selectedSize || {}).value,
                    gender: (this.selectedGender || {}).value,
                    category: (this.selectedCategory || {}).value,
                });
            },

            deliveryReadyShirtsUrl() {
                return this.buildUrl('camiseta', {
                    size: (this.selectedSize || {}).value,
                    gender: (this.selectedGender || {}).value,
                    category: (this.selectedCategory || {}).value,
                    deliveryReady: true,
                });
            },
        },

        methods: {
            sendMessage(iteration, event) {
                const pushMessage = (type, content, side, iteration, options = []) => {
                    this.messages.push({ type, content, side, iteration, options });
                };

                switch (iteration) {
                    case 0:
                        this.events.push(event);
                        this.messages.push({ type: 'text', content: this.currentMessage, side: 2 });
                        setTimeout(() => {
                            this.messages.push({
                                type: 'text',
                                content:
                                    'Olá! Chega junto que eu te ajudo a encontrar o presente perfeito!',
                                side: 1,
                            });
                            pushMessage(
                                'text',
                                'Primeiro, escolhe aqui o tipo de presente que você quer dar:',
                                1,
                                1,
                                [
                                    {
                                        text: 'Camisetas',
                                        event: { name: 'Camisetas', value: 'camisetas' },
                                    },
                                    { text: 'Roupas', event: { name: 'Roupas', value: 'roupas' } },
                                    {
                                        text: 'Acessórios',
                                        event: { name: 'Acessórios', value: 'acessorios' },
                                    },
                                    {
                                        text: 'Casa e decoração',
                                        event: { name: 'Casa e decoração', value: 'casa' },
                                    },
                                ]
                            );
                        }, 1500);
                        this.currentMessage = '';
                        setTimeout(() => {
                            this.goLastMessage();
                        }, 1000);
                        break;

                    case 1:
                        this.events.push(event);
                        if (event.value === 'camisetas') {
                            this.showShirts = { label: 'Camisetas', value: true };
                            pushMessage('text', event.name, 2);
                            pushMessage('text', 'Eba! Essa é a nossa especialidade!', 1);
                            pushMessage('text', 'Escolha agora uma modelagem:', 1, 2, [
                                { text: 'Regular', event: { name: 'Regular', value: 'regular' } },
                                {
                                    text: 'Babylook',
                                    event: { name: 'Babylook', value: 'babylook' },
                                },
                                {
                                    text: 'Infantil',
                                    event: { name: 'Infantil', value: 'infantil' },
                                },
                            ]);
                        } else if (event.value === 'roupas') {
                            pushMessage('text', event.name, 2);
                            this.messages.push({
                                type: 'text',
                                content: 'Já deu pra ver que de roupa a gente entende, né? ',
                                side: 1,
                            });
                            pushMessage('text', 'Escolha agora um desses produtos:', 1, 2, [
                                {
                                    text: 'Camiseta',
                                    event: { name: 'Camiseta', value: 'camiseta' },
                                },
                                {
                                    text: 'Camisa de botão',
                                    event: { name: 'Camisa de botão', value: 'camisa-de-botao' },
                                },
                                { text: 'Regata', event: { name: 'Regata', value: 'regata' } },
                                { text: 'Cropped', event: { name: 'Cropped', value: 'cropped' } },
                                { text: 'Calça', event: { name: 'Calça', value: 'calca' } },
                                { text: 'Bermuda', event: { name: 'Bermuda', value: 'bermuda' } },
                                { text: 'Shorts', event: { name: 'Shorts', value: 'shorts' } },
                                { text: 'Meia', event: { name: 'Meia', value: 'meia' } },
                                { text: 'Moletom', event: { name: 'Moletom', value: 'moletom' } },
                            ]);
                        } else if (event.value === 'acessorios') {
                            pushMessage('text', event.name, 2);
                            this.messages.push({
                                type: 'text',
                                content: 'Ótima escolha! ',
                                side: 1,
                            });
                            pushMessage('text', 'Escolha agora um desses produtos:', 1, 2, [
                                { text: 'Bonés', event: 'bone' },
                                {
                                    text: 'Bolsas e Mochilas',
                                    event: {
                                        name: 'Bolsas e Mochilas',
                                        value: 'bolsas-e-mochilas/',
                                    },
                                },
                                {
                                    text: 'Garrafas Térmicas',
                                    event: { name: 'Garrafas Térmicas', value: 'garrafas' },
                                },
                                {
                                    text: 'Sketchbooks',
                                    event: { name: 'Sketchbooks', value: 'sketchbook' },
                                },
                            ]);
                        } else {
                            pushMessage('text', event.name, 2);
                            this.messages.push({
                                type: 'text',
                                content: 'Quem não ama um mimo para decorar a casinha, né?! ',
                                side: 1,
                            });
                            pushMessage('text', 'Escolha agora um desses produtos:', 1, 2, [
                                {
                                    text: 'Bandeira',
                                    event: { name: 'Bandeira', value: 'bandeira' },
                                },
                                { text: 'Caneca', event: { name: 'Caneca', value: 'caneca' } },
                                { text: 'Poster', event: { name: 'Poster', value: 'poster' } },
                            ]);
                        }
                        setTimeout(() => {
                            this.goLastMessage();
                        }, 1000);
                        break;

                    case 2:
                        this.events.push(event);
                        if (['regular', 'babylook', 'infantil'].includes(event.value)) {
                            this.selectedGender = {
                                label: event.name,
                                value: event.value,
                            };
                            pushMessage('text', event.name, 2);
                            pushMessage('text', 'Beleza! E qual é o tamanho?', 1, 3, [
                                { text: 'P', event: { name: 'P', value: 'tamanho-p' } },
                                { text: 'M', event: { name: 'M', value: 'tamanho-m' } },
                                { text: 'G', event: { name: 'G', value: 'tamanho-g' } },
                                { text: 'GG', event: { name: 'GG', value: 'tamanho-gg' } },
                                { text: '2GG', event: { name: '2GG', value: 'tamanho-2gg' } },
                                { text: '3GG', event: { name: '3GG', value: 'tamanho-3gg' } },
                                { text: '4GG', event: { name: '4GG', value: 'tamanho-4gg' } },
                            ]);
                        } else if (
                            [
                                'camiseta',
                                'camisa-de-botao',
                                'regata',
                                'cropped',
                                'calca',
                                'bermuda',
                                'shorts',
                                'meia',
                                'moletom',
                            ].includes(event.value)
                        ) {
                            pushMessage('text', event.name, 2);
                            this.messages.push({
                                type: 'text',
                                content: 'Entendido! ',
                                side: 1,
                            });
                            pushMessage(
                                'text',
                                'Com base nas suas respostas, criamos uma lista de produtos personalizada para você! Clica aqui para ver suas opções: ',
                                1,
                                3,
                                [
                                    {
                                        text: 'Link para a lista',
                                        event: { name: 'Link para a lista', value: 'link-lista' },
                                    },
                                ]
                            );
                        } else if (
                            ['bone', 'bolsas-e-mochilas/', 'garrafas', 'sketchbook'].includes(
                                event.value
                            )
                        ) {
                            pushMessage('text', event.name, 2);
                            this.messages.push({
                                type: 'text',
                                content: 'Entendido! ',
                                side: 1,
                            });
                            pushMessage(
                                'text',
                                'Com base nas suas respostas, criamos uma lista de produtos personalizada para você! Clica aqui para ver suas opções: ',
                                1,
                                3,
                                [
                                    {
                                        text: 'Link para a lista',
                                        event: { name: 'Link para a lista', value: 'link-lista' },
                                    },
                                ]
                            );
                        } else if (['caneca', 'poster'].includes(event.value)) {
                            this.selectedTypeProduct = event.value;
                            pushMessage('text', event.name, 2);
                            pushMessage(
                                'text',
                                'Entendido! Agora a pergunta mais importante: qual desses temas tem mais a ver com a pessoa que vai ganhar o presente?',
                                1,
                                4,
                                [
                                    { text: 'Todos', event: { name: 'Todos', value: 'todos' } },
                                    {
                                        text: 'Cinema',
                                        event: { name: 'Cinema', value: 'de-filmes' },
                                    },
                                    { text: 'Série', event: { name: 'Série', value: 'serie' } },
                                    { text: 'Geek', event: { name: 'Geek', value: 'geek' } },
                                    { text: 'Games', event: { name: 'Games', value: 'games' } },
                                    {
                                        text: 'Brasilidade',
                                        event: { name: 'Brasilidade', value: 'brasilidade' },
                                    },
                                    {
                                        text: 'Literatura',
                                        event: { name: 'Literatura', value: 'literatura' },
                                    },
                                    { text: 'Música', event: { name: 'Música', value: 'musica' } },
                                    { text: 'Humor', event: { name: 'Humor', value: 'humor' } },
                                ]
                            );
                        } else if (event.value === 'bandeira') {
                            this.selectedTypeProduct = event.value;
                            pushMessage('text', event.name, 2);
                            pushMessage(
                                'text',
                                'Com base nas suas respostas, criamos uma lista de produtos personalizada para você! Clica aqui para ver suas opções: ',
                                1,
                                3,
                                [
                                    {
                                        text: 'Link para a lista',
                                        event: { name: 'Link para a lista', value: 'link-lista' },
                                    },
                                ]
                            );
                        } else {
                            this.selectedCategory = {
                                label: event.name,
                                value: event.value === 'todos' ? null : event.value,
                            };
                            pushMessage('text', event.name, 2);
                            pushMessage('text', 'Produtos', 1, 3, [
                                { text: 'Canecas', event: { name: 'Canecas', value: 'caneca' } },
                                { text: 'Meias', event: { name: 'Meias', value: 'meia' } },
                                { text: 'Posters', event: { name: 'Posters', value: 'poster' } },
                                {
                                    text: 'Sketchbooks',
                                    event: { name: 'Sketchbooks', value: 'sketchbook' },
                                },
                                {
                                    text: 'Vale-Presente',
                                    event: { name: 'Vale-Presente', value: 'vale-presente' },
                                },
                            ]);
                        }
                        setTimeout(() => {
                            this.goLastMessage();
                        }, 1000);
                        break;

                    case 3:
                        this.events.push(event);
                        if (['caneca', 'meia', 'poster', 'sketchbook'].includes(event.value)) {
                            this.selectedTypeProduct = event.value;
                            pushMessage('text', event.name, 2);
                            window.location.href = this.url;
                        } else if (event.value === 'vale-presente') {
                            pushMessage('text', event.name, 2);
                            window.location.href = '/vale-presente';
                        } else if (event.value === 'link-lista') {
                            window.location.href = this.$scope.URL + this.events[2].value;
                        } else {
                            this.selectedSize = { label: event.name, value: event.value };
                            pushMessage('text', event.name, 2);
                            pushMessage(
                                'text',
                                'Entendido! Agora a pergunta mais importante: qual desses temas tem mais a ver com a pessoa que vai ganhar o presente?',
                                1,
                                4,
                                [
                                    { text: 'Todos', event: { name: 'Todos', value: 'todos' } },
                                    {
                                        text: 'Cinema',
                                        event: { name: 'Cinema', value: 'de-filmes' },
                                    },
                                    { text: 'Série', event: { name: 'Série', value: 'serie' } },
                                    { text: 'Geek', event: { name: 'Geek', value: 'geek' } },
                                    { text: 'Games', event: { name: 'Games', value: 'games' } },
                                    {
                                        text: 'Brasilidade',
                                        event: { name: 'Brasilidade', value: 'brasilidade' },
                                    },
                                    {
                                        text: 'Literatura',
                                        event: { name: 'Literatura', value: 'literatura' },
                                    },
                                    { text: 'Música', event: { name: 'Música', value: 'musica' } },
                                    { text: 'Humor', event: { name: 'Humor', value: 'humor' } },
                                ]
                            );
                        }
                        setTimeout(() => {
                            this.goLastMessage();
                        }, 1000);
                        break;

                    case 4:
                        if (this.events[1].value !== 'camisetas') {
                            pushMessage('text', event.name, 2);
                            window.location.href =
                                this.$scope.URL + this.events[2].value + '/' + event.value;
                            break;
                        }

                        this.events.push(event);
                        this.selectedCategory = {
                            label: event.name,
                            value: event.value === 'todos' ? null : event.value,
                        };
                        pushMessage('text', event.name, 2);
                        pushMessage('text', 'Quer receber rápido ?', 1, 5, [
                            {
                                text: 'Filtrar por envio rápido',
                                event: { name: 'Filtrar por envio rápido', value: 'envio-rapido' },
                            },
                            {
                                text: 'Ver todos os produtos',
                                event: { name: 'Ver todos os produtos', value: 'todos-produtos' },
                            },
                        ]);
                        setTimeout(() => {
                            this.goLastMessage();
                        }, 1000);
                        break;
                    case 5:
                        this.events.push(event);
                        pushMessage('text', event.name, 2);
                        if (event.value === 'envio-rapido') {
                            window.location.href = this.deliveryReadyShirtsUrl;
                        } else {
                            window.location.href = this.shirtsUrl;
                        }
                        setTimeout(() => {
                            this.goLastMessage();
                        }, 1000);
                        break;

                    default:
                        break;
                }
            },

            closeChat() {
                this.openChat = false;
                this.currentMessage = 'Olá, Chico! Quero ajuda para escolher um presente';
                this.events = [];
                this.messages = [];
            },

            goToProductSize(theme, size, isRegular) {
                this.selectedGender = isRegular ? '/regular' : '/babylook';
                this.selectedSize = '/tamanho-' + size + '/';
                this.selectedCategory = theme;
                return (
                    this.$scope.URL +
                    'camiseta/' +
                    this.selectedCategory +
                    this.selectedGender +
                    this.selectedSize +
                    '?inPhysicalStock=1'
                );
            },

            computeUrls() {
                this.computedUrls = this.sendImmediate.map((item) => {
                    return this.sizes.map((size) =>
                        this.goToProductSize(item.theme, size, !!item.regularEffect)
                    );
                });
            },

            goLastMessage() {
                const element = document.getElementById('all-messages');
                const start = element.scrollTop;
                const end = element.scrollHeight;
                const duration = 500; // duração em milissegundos
                const startTime = performance.now();

                const animateScroll = (currentTime) => {
                    const timeElapsed = currentTime - startTime;
                    const progress = Math.min(timeElapsed / duration, 1);
                    const ease = this.easeInOutCubic(progress);

                    element.scrollTop = start + (end - start) * ease;

                    if (progress < 1) {
                        requestAnimationFrame(animateScroll);
                    }
                };

                requestAnimationFrame(animateScroll);
            },

            easeInOutCubic(t) {
                return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
            },
        },
    };
</script>
